module.exports = __webpack_public_path__ + "static/media/situation_pin.2821ebb1.png";